import styled from "styled-components";

const MatchBlock = styled.div`
  margin-bottom: 1rem;
  border-top: 1px solid #ddd;
  padding: 1rem;
  font-family: "Mark For MC Narrow W00 Light";
`;

const MatchHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.75rem;
`;

const MatchHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

const MatchHeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  flex-shrink: 0;
`;

const LeagueName = styled.div`
  font-size: 1rem;
  font-family: "Mark For MC Narrow W00 Bold";
  line-height: 1.2;
`;

const CourtRound = styled.div`
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #666;
  line-height: 1.3;
`;

const StatusTag = styled.span`
  background-color: ${({ warning }) => (warning ? "#f5e6e0" : "#e5f5ec")};
  color: ${({ warning }) => (warning ? "#8b4513" : "#2a9d8f")};
  font-size: 0.65rem;
  padding: 0.2rem 0.45rem;
  border-radius: 4px;
  border: 1px solid ${({ warning }) => (warning ? "#d4a574" : "#2a9d8f")};
  font-family: "Mark For MC Narrow W00 Bold";
  letter-spacing: 0.03em;
  white-space: nowrap;
`;

const ScoreRow = styled.tr`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.25rem;
  width: 100%;
`;

const PlayerCell = styled.td`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
`;

const PlayerName = styled.div`
  font-size: 1rem;
  font-weight: 500;
  font-weight: ${({ winner }) => (winner ? "bold" : "normal")};
  font-family: ${({ winner }) =>
    winner ? "Mark For MC Narrow W00 Bold" : "Mark For MC Narrow W00 Light"};
  /* color: ${({ winner }) => (winner ? "inherit" : "gray")}; */
`;

const ScoreCell = styled.td`
  width: 1.1rem;
  text-align: center;
  font-weight: 500;
  color: ${({ highlighted }) => (highlighted ? "green" : "inherit")};
`;

// const CheckMark = styled.span`
//   color: green;
//   font-weight: bold;
//   margin-left: 0.5rem;
// `;

const Flag = styled.img`
  width: 20px;
  height: 14px;
`;

const TimeText = styled.div`
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.25rem;
`;

const ScoresContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ScoreSection = styled.td`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export {
  MatchBlock,
  MatchHeader,
  MatchHeaderLeft,
  MatchHeaderRight,
  LeagueName,
  CourtRound,
  StatusTag,
  ScoreRow,
  PlayerCell,
  PlayerName,
  ScoreCell,
  ScoresContainer,
  ScoreSection,
  TimeText,
  Flag
};
